import { render, staticRenderFns } from "./BtnBuscar.vue?vue&type=template&id=0a85af24&"
import script from "./BtnBuscar.vue?vue&type=script&lang=js&"
export * from "./BtnBuscar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports